// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.formSecurity_wrap__XzoS8 {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  margin-top: 1.25rem;
}
/* The Google widget is a fixed 304px wide; scale it down on very narrow screens. */
.formSecurity_widget__wh5Xa {
  min-height: 78px;
}
@media (max-width: 360px) {
  .formSecurity_widget__wh5Xa {
    transform: scale(0.88);
    transform-origin: center top;
  }
}
.formSecurity_honeypot__SZO2A {
  position: absolute !important;
  left: -10000px;
  width: 1px;
  height: 1px;
  overflow: hidden;
}
.formSecurity_note__PcN-m {
  margin: 0;
  font-size: 0.85rem;
  opacity: 0.75;
}
.formSecurity_error__ACHCx {
  margin: 0;
  font-size: 0.875rem;
  color: #ff6b6b;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/COMPONENTS/FORM_SECURITY/formSecurity.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;AACA,mFAAmF;AACnF;EACE,gBAAgB;AAClB;AACA;EACE;IACE,sBAAsB;IACtB,4BAA4B;EAC9B;AACF;AACA;EACE,6BAA6B;EAC7B,cAAc;EACd,UAAU;EACV,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,SAAS;EACT,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB","sourcesContent":[".wrap {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.5rem;\n  margin-top: 1.25rem;\n}\n/* The Google widget is a fixed 304px wide; scale it down on very narrow screens. */\n.widget {\n  min-height: 78px;\n}\n@media (max-width: 360px) {\n  .widget {\n    transform: scale(0.88);\n    transform-origin: center top;\n  }\n}\n.honeypot {\n  position: absolute !important;\n  left: -10000px;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n}\n.note {\n  margin: 0;\n  font-size: 0.85rem;\n  opacity: 0.75;\n}\n.error {\n  margin: 0;\n  font-size: 0.875rem;\n  color: #ff6b6b;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `formSecurity_wrap__XzoS8`,
	"widget": `formSecurity_widget__wh5Xa`,
	"honeypot": `formSecurity_honeypot__SZO2A`,
	"note": `formSecurity_note__PcN-m`,
	"error": `formSecurity_error__ACHCx`
};
export default ___CSS_LOADER_EXPORT___;
